import { lazy, Suspense, ComponentProps } from 'react'
import Loader from 'components/SimpleLoader'

const Settings = lazy(() => import(
  /* webpackPrefetch: true */
  /* webpackChunkName: 'settings' */
  './Settings'
))

export function AsyncSettings(props: ComponentProps<any>) {
  return (
    <Suspense fallback={<Loader title="Loading Settings..." />}>
      <Settings {...props} />
    </Suspense>
  )
}

export default AsyncSettings
